// Tab is opened synchronously in the click so popup blockers allow it, then
// pointed at the URL once the authed request resolves. If the tab was blocked
// anyway, the URL is a download, so the page stays.
export const openInNewTab = async (resolveUrl, onError) => {
  const tab = window.open('', '_blank');

  try {
    const url = await resolveUrl();

    if (tab) tab.location.href = url;
    else window.location.assign(url);
  } catch (error) {
    tab?.close();
    onError(error);
  }
};
